__turbopack_context__.v({
  "className": "inter_4b54a8e5-module___PpHUq__className",
});
